import React, { useRef } from "react";
import DataTable from "react-data-table-component";
import ClipLoader from "react-spinners/ClipLoader";
import moment from "moment";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { TbEdit, TbEye, TbTrash, TbSettings } from "react-icons/tb";
import { IoMdSearch } from "react-icons/io";

import styles from "@areas/shared/pages/personal/frames/statistics/contracts/blocks/styles/allTable.module.css";

import { types } from "./ModalAdd";

function Table({
  load,
  data,
  total,
  handlePageChange,
  handlePerRowsChange,
  toggleModal,
  toggleView,
  toggleDelete,
  onSearch,
}) {
  const searchRef = useRef();
  const paginationOptions = {
    rowsPerPageText: "Данных на странице:",
    rangeSeparatorText: "из",
    noRowsPerPage: false,
    selectAllRowsItem: false,
    selectAllRowsItemText: "Все",
  };

  const typeLabel = (idType) => {
    const found = types.find((t) => t.value === idType);
    return found ? found.label : idType || "—";
  };

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Код</span>,
      selector: (row) => row.Id,
      sortable: true,
      width: "8%",
    },
    {
      name: <span className="font-weight-bold fs-13">Компания</span>,
      selector: (row) =>
        row.NameCompany ||
        row.Shortname ||
        row.Fullname ||
        (row.IdCompany ? `#${row.IdCompany}` : "—"),
      sortable: true,
      width: "18%",
      wrap: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Наименование</span>,
      selector: (row) => row.Name,
      sortable: true,
      width: "22%",
      wrap: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Тип</span>,
      selector: (row) => typeLabel(row.IdType),
      sortable: true,
      width: "14%",
    },
    {
      name: <span className="font-weight-bold fs-13">Дата</span>,
      selector: (row) =>
        row.DateStart ? moment(row.DateStart).format("DD.MM.YYYY") : "—",
      sortable: true,
      width: "12%",
    },
    {
      name: <span className="font-weight-bold fs-13">Описание</span>,
      selector: (row) => row.Description || "—",
      sortable: false,
      width: "16%",
      wrap: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Действия</span>,
      sortable: false,
      width: "10%",
      center: true,
      compact: true,
      cell: (cellProps) => {
        return (
          <UncontrolledDropdown className="dropdown d-inline-block">
            <DropdownToggle
              className="btn btn-outline-secondary btn-sm d-flex justify-content-center"
              tag="button"
            >
              <TbSettings size={18} />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem
                className="view-item-btn"
                onClick={() => toggleView(cellProps)}
              >
                <TbEye size={16} className="me-2" />
                Просмотр
              </DropdownItem>
              <DropdownItem
                className="edit-item-btn"
                onClick={() => toggleModal(cellProps)}
              >
                <TbEdit size={16} className="me-2" />
                Изменить
              </DropdownItem>
              <DropdownItem
                className="remove-item-btn"
                onClick={() => toggleDelete(cellProps)}
              >
                <TbTrash size={16} className="me-2" />
                Удалить
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      },
    },
  ];

  const submitSearch = () => {
    onSearch(searchRef.current.value);
  };

  return (
    <>
      <div className={styles.search}>
        <input
          type="text"
          placeholder="Поиск по наименованию"
          ref={searchRef}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              submitSearch();
            }
          }}
        />
        <div
          className={`btn btn-outline-secondary ${styles.btn}`}
          onClick={submitSearch}
        >
          <IoMdSearch size={25} />
        </div>
      </div>
      <DataTable
        columns={columns}
        data={data}
        progressComponent={<ClipLoader />}
        progressPending={load}
        paginationTotalRows={total}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        pagination
        paginationServer
        paginationComponentOptions={paginationOptions}
      />
    </>
  );
}

export default Table;
